export interface VenueStadium {
  name: string;
  capacity: number;
  ratingLevel: number;
  facilitiesRatingLevel: number;
}

/** Match data is an atomic snapshot of the home stadium, even for an away viewer. */
export function resolveVenueStadium(
  match: { stadium?: Partial<VenueStadium> | null } | null,
  ownStadium: Partial<VenueStadium> | null,
  isHome: boolean,
): VenueStadium | null {
  const stadium = match ? match.stadium : isHome ? ownStadium : null;
  if (!stadium || !stadium.name?.trim() || !Number.isFinite(stadium.capacity) || stadium.capacity! <= 0) return null;
  for (const rating of [stadium.ratingLevel, stadium.facilitiesRatingLevel]) {
    if (typeof rating !== 'number' || !Number.isFinite(rating) || rating < 1 || rating > 5) return null;
  }
  return {
    name: stadium.name,
    capacity: stadium.capacity!,
    ratingLevel: stadium.ratingLevel!,
    facilitiesRatingLevel: stadium.facilitiesRatingLevel!,
  };
}
